import { cn } from '@tebuto/lib/utils'

export default function SmallText({
    children,
    className,
    ...rest
}: { children?: React.ReactNode } & React.HTMLAttributes<HTMLParagraphElement>) {
    return (
        <p {...rest} className={cn('md:text-xs text-xxs text-foreground-tertiary', className)}>
            {children}
        </p>
    )
}
